import Vue from "vue";
import VueRouter from "vue-router";
import { Message, MessageBox } from "element-ui";
import Layout from "@/views/layout1/index.vue";
// import ThirdMenu from '@/views/ThirdMenu/index.vue'
import store from "../store/index";
import { SDKInit } from "@/SDK/SDK_Init";
import { MD5 } from "crypto-js";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login_face/login.vue"),
    hidden: true,
  },
  {
    path: "/",
    component: () => import("@/views/homePage/index.vue"),
    hidden: true,
  },
];

// 监督决定
export const supervisionDecision = [
  {
    path: "/supervisionDecision",
    component: Layout,
    redirect: "/supervisionDecision",
    children: [
      {
        path: "supervisionDecision",
        name: "supervisionDecision",
        component: () => import("@/views/supervision/index.vue"),
        meta: {
          title: "监督决定",
          roles: ["JDJD-JDJD"],
          menuName: "监督决定",
        },
      },
    ],
  },
];

// 人事任免
export const appointmentRemoval = [
  {
    path: "/appointmentRemoval",
    component: Layout,
    redirect: "/appointmentRemoval",
    children: [
      {
        path: "appointmentRemoval",
        name: "appointmentRemoval",
        component: () =>
          import("@/views/appointmentRemoval/appointmentRemoval/index.vue"),
        meta: {
          title: "人事任免",
          roles: ["RSRM-RSRM"],
          menuName: "人事任免",
        },
      },
    ],
  },
  {
    path: "/lawTest",
    component: Layout,
    redirect: "/lawTest",
    children: [
      {
        path: "lawTest",
        name: "lawTest",
        component: () => import("@/views/appointmentRemoval/lawTest/index.vue"),
        meta: {
          title: "法律考试",
          roles: ["RSRM-FLKS"],
          menuName: "人事任免",
        },
      },
    ],
  },
];

// 人大票决
export const voteOfPeople = [
  {
    path: "/voteRelease",
    component: Layout,
    redirect: "/voteRelease",
    children: [
      {
        path: "voteRelease",
        name: "voteRelease",
        component: () => import("@/views/peopleVote/voteRelease/index.vue"),
        meta: {
          title: "票决发布",
          roles: ["RDPJ-PJFB"],
          menuName: "人大票决",
        },
      },
    ],
  },
  {
    path: "/voteProject",
    component: Layout,
    redirect: "/voteProject",
    children: [
      {
        path: "voteProject",
        name: "voteProject",
        component: () => import("@/views/peopleVote/voteProject/index.vue"),
        meta: {
          title: "票决项目",
          roles: ["RDPJ-PJXM"],
          menuName: "人大票决",
        },
      },
    ],
  },
];

// 会议管理
export const meetingManagement = [
  {
    path: "/meetingManagement",
    component: Layout,
    redirect: "/meetingManagement",
    children: [
      {
        path: "meetingManagement",
        name: "meetingManagement",
        component: () =>
          import("@/views/MettingManagement/meetingManagement/index.vue"),
        meta: {
          title: "会议管理",
          roles: ["HYGL-HYGL"],
          menuName: "会议管理",
        },
      },
    ],
  },
  {
    path: "/importantRelease",
    component: Layout,
    redirect: "/importantRelease",
    children: [
      {
        path: "importantRelease",
        name: "importantRelease",
        component: () =>
          import("@/views/MettingManagement/importantRelease/index.vue"),
        meta: {
          title: "重要发布",
          roles: ["HYGL-ZYFB"],
          menuName: "会议管理",
        },
      },
    ],
  },
  {
    path: "/selfConstruction",
    component: Layout,
    redirect: "/selfConstruction",
    children: [
      {
        path: "selfConstruction",
        name: "selfConstruction",
        component: () =>
          import("@/views/MettingManagement/selfConstruction/index.vue"),
        meta: {
          title: "自身建设",
          roles: ["HYGL-ZSJS"],
          menuName: "会议管理",
        },
      },
    ],
  },
  {
    path: "/videoMeeting",
    component: Layout,
    redirect: "/videoMeeting",
    children: [
      {
        path: "videoMeeting",
        name: "videoMeeting",
        component: () =>
          import("@/views/MettingManagement/videoMeeting/index.vue"),
        meta: {
          title: "视频会议",
          roles: ["VIDEO_MEETING"],
          menuName: "会议管理",
        },
        beforeEnter: async (to, from, next) => {
          await SDKInit.init();
          const isLogin = store.getters.UID;
          const params = {
            addr: "sdk.cloudroom.com",
            AppId: "9jnpvfenev",
            MD5_AppSecret: MD5("qxlzvmca").toString(),
          };
          if (isLogin) {
            next();
          } else {
            try {
              await store.dispatch("meeting_user/login", params);
              next({ ...to, replace: true });
            } catch (error) {
              console.log(error);
            }
          }
        },
      },
    ],
  },
];

// 意见办理
export const commentsHandle = [
  {
    path: "/representativeSuggest",
    component: Layout,
    redirect: "/representativeSuggest",
    meta: {
      title: "意见办理",
      roles: ["YJBL"],
    },
    children: [
      {
        path: "representativeSuggest",
        name: "representativeSuggest",
        component: () =>
          import("@/views/commentsHandle/representativeSuggest/index.vue"),
        meta: {
          title: "人代会建议议案",
          roles: ["YJBL-RDHJYYA"],
          menuName: "意见办理",
        },
      },
      {
        path: "closeMeeting",
        name: "closeMeeting",
        component: () =>
          import("@/views/commentsHandle/closeMeeting/index.vue"),
        meta: {
          title: "闭会期间建议",
          roles: ["YJBL-BHQJJY"],
          menuName: "意见办理",
        },
      },
      {
        path: "deliberationOpinions",
        name: "deliberationOpinions",
        component: () =>
          import("@/views/commentsHandle/deliberationOpinions/index.vue"),
        meta: {
          title: "审议意见",
          roles: ["YJBL-SYYJ"],
          menuName: "意见办理",
        },
      },
    ],
  },
];

// 代表服务
export const representativeService = [
  {
    path: "/representativeManagement",
    component: Layout,
    redirect: "/repManagement",
    meta: {
      title: "代表管理",
      roles: ["DBFW-DBGL"],
      menuName: "代表服务",
    },
    children: [
      {
        path: "repManagement",
        name: "repManagement",
        component: () =>
          import(
            "@/views/representativeService/representativeManagement/representativeManagement/index.vue"
          ),
        meta: {
          title: "代表管理",
          roles: ["DBFW-DBGL-DBGL"],
          menuName: "代表服务",
        },
      },
      {
        path: "notRepManagement",
        name: "notRepManagement",
        component: () =>
          import(
            "@/views/representativeService/representativeManagement/notRepresentativeManagement/index.vue"
          ),
        meta: {
          title: "非代表管理",
          roles: ["DBFW-DBGL-FDBGL"],
          menuName: "代表服务",
        },
      },
      {
        path: "employmentStatistics",
        name: "employmentStatistics",
        component: () =>
          import(
            "@/views/representativeService/representativeManagement/employmentStatistics/index.vue"
          ),
        meta: {
          title: "任职统计",
          roles: ["DBFW-DBGL-RZTJ"],
          menuName: "代表服务",
        },
      },
      {
        path: "pointsRanking",
        name: "pointsRanking",
        component: () =>
          import(
            "@/views/representativeService/representativeManagement/pointsRanking/index.vue"
          ),
        meta: {
          title: "积分排名",
          roles: ["DBFW-DBGL-JFPM"],
          menuName: "代表服务",
        },
      },
      // {
      //   path: 'selfConstruction',
      //   name: 'selfConstruction',
      //   component: () => import('@/views/MettingManagement/selfConstruction/index.vue'),
      //   meta: {
      //     title: '自身建设',
      //     roles: ['XTGL-XTGL-JJGL'],
      //     menuName: '代表服务'
      //   }
      // }
    ],
  },
  {
    path: "/votersregistration",
    component: Layout,
    redirect: "/votersregistration",
    meta: {
      title: "选民登记",
      roles: ["DBFW-XMDJ"],
      menuName: "代表服务",
    },
    children: [
      {
        path: "votersregistration",
        name: "votersregistration",
        component: () =>
          import("@/views/representativeService/votersRegistration/index.vue"),
        meta: {
          title: "选民登记",
          roles: ["DBFW-XMDJ-XMDJ"],
          menuName: "代表服务",
        },
      },
    ],
  },
  {
    path: "/representativeService",
    component: Layout,
    redirect: "/representativeService",
    meta: {
      title: "代表履职",
      roles: ["DBFW-DBLZ"],
      menuName: "代表服务",
    },
    children: [
      {
        path: "wishHeart",
        name: "wishHeart",
        component: () =>
          import(
            "@/views/representativeService/representativePerform/wishHeart/index.vue"
          ),
        meta: {
          title: "微心愿",
          roles: ["DBFW-DBLZ-WXY"],
          menuName: "代表服务",
        },
      },
      {
        path: "doubleConnection",
        name: "doubleConnection",
        component: () =>
          import(
            "@/views/representativeService/representativePerform/doubleConnection/index.vue"
          ),
        meta: {
          title: "双联系",
          roles: ["DBFW-DBLZ-SLX"],
          menuName: "代表服务",
        },
      },
      {
        path: "exchange",
        name: "exchange",
        component: () =>
          import(
            "@/views/representativeService/representativePerform/exchange/index.vue"
          ),
        meta: {
          title: "服务交流",
          roles: ["DBFW-DBLZ-FWJL"],
          menuName: "代表服务",
        },
      },
      {
        path: "release",
        name: "release",
        component: () =>
          import(
            "@/views/representativeService/representativePerform/release/index.vue"
          ),
        meta: {
          title: "履职发布",
          roles: ["DBFW-DBLZ-LZFB"],
          menuName: "代表服务",
        },
      },
      {
        path: "dutyActivity",
        name: "dutyActivity",
        component: () =>
          import(
            "@/views/representativeService/representativePerform/dutyActivity/index.vue"
          ),
        meta: {
          title: "履职活动",
          roles: ["DBFW-DBLZ-LZHD"],
          menuName: "代表服务",
        },
      },
    ],
  },
  {
    path: "/standLearn",
    component: Layout,
    redirect: "/standLearn",
    meta: {
      title: "代表学习",
      roles: ["DBFW-DBXX"],
      menuName: "代表服务",
    },
    children: [
      {
        path: "gardenLearn",
        name: "gardenLearn",
        component: () =>
          import(
            "@/views/representativeService/standLearn/gardenLearn/index.vue"
          ),
        meta: {
          title: "代表学习园地",
          roles: ["DBFW-DBXX-DBXXYD"],
          menuName: "代表服务",
        },
      },
      {
        path: "readingStatistics",
        name: "readingStatistics",
        component: () =>
          import(
            "@/views/representativeService/standLearn/readingStatistics/index.vue"
          ),
        meta: {
          title: "阅读统计",
          roles: ["DBFW-DBXX-YDTJ"],
          menuName: "代表服务",
        },
      },
    ],
  },
];

// 代表家站
export const representativeStation = [
  {
    path: "/representativeStation",
    component: Layout,
    redirect: "/representativeStation",
    meta: {
      title: "代表家站",
      roles: ["DBJZ"],
    },
    children: [
      {
        path: "representativeStation",
        name: "representativeStation",
        component: () =>
          import(
            "@/views/representativeStation/representativeStation/index.vue"
          ),
        meta: {
          title: "代表家站",
          roles: ["DBJZ-DBJZ"],
          menuName: "代表家站",
        },
      },
      {
        path: "stationDynamics",
        name: "stationDynamics",
        component: () =>
          import("@/views/representativeStation/stationDynamics/index.vue"),
        meta: {
          title: "家站动态",
          roles: ["DBJZ-JZDT"],
          menuName: "代表家站",
        },
      },
    ],
  },
];

// 乡镇人大
export const ruralNPC = [
  {
    path: "/ruralManagement",
    component: Layout,
    meta: {
      title: "乡镇人大",
      roles: ["XZRD"],
    },
    redirect: "/ruralManagement",
    children: [
      {
        path: "ruralManagement",
        name: "ruralManagement",
        component: () => import("@/views/ruralNPC/ruralManagement/index.vue"),
        meta: {
          title: "乡镇管理",
          roles: ["XZRD-XZGL"],
          menuName: "乡镇人大",
        },
      },
      {
        path: "dynamic",
        name: "dynamic",
        component: () => import("@/views/ruralNPC/dynamic/index.vue"),
        meta: {
          title: "乡镇动态",
          roles: ["XZRD-XZDT"],
          menuName: "乡镇人大",
        },
      },
    ],
  },
];

// 审核发布
export const auditRelease = [
  {
    path: "/auditRelease",
    component: Layout,
    redirect: "/auditRelease",
    children: [
      {
        path: "auditRelease",
        name: "auditRelease",
        component: () => import("@/views/auditRelease/index.vue"),
        meta: {
          title: "审核发布",
          roles: ["SHFB-SHFB"],
          menuName: "审核发布",
        },
      },
    ],
  },
];

// 系统管理
export const systemManagement = [
  {
    path: "/system",
    component: Layout,
    redirect: "/system",
    meta: {
      title: "系统管理",
      roles: ["XTGL-XTGL"],
      menuName: "系统管理",
    },
    children: [
      {
        path: "organizationalStructure",
        name: "organizationalStructure",
        component: () =>
          import(
            "@/views/systemManagement/system/organizationalStructure/index.vue"
          ),
        meta: {
          title: "组织架构",
          roles: ["XTGL-XTGL-ZZJG"],
          menuName: "系统管理",
        },
      },
      {
        path: "roleManagement",
        name: "roleManagement",
        component: () =>
          import("@/views/systemManagement/system/roleManagement/index.vue"),
        meta: {
          title: "角色管理",
          roles: ["XTGL-XTGL-JJGL"],
          menuName: "系统管理",
        },
      },
      {
        path: "personnelManagement",
        name: "personnelManagement",
        component: () =>
          import(
            "@/views/systemManagement/system/personnelManagement/index.vue"
          ),
        meta: {
          title: "人员管理",
          roles: ["XTGL-XTGL-RRGL"],
          menuName: "系统管理",
        },
      },
      {
        path: "messageManagement",
        name: "messageManagement",
        component: () =>
          import("@/views/systemManagement/system/messageManagement/index.vue"),
        meta: {
          title: "通知管理",
          roles: ["XTGL-XTGL-TZGL"],
          menuName: "系统管理",
        },
      },
      {
        path: "messageRecord",
        name: "messageRecord",
        component: () =>
          import("@/views/systemManagement/system/messageRecord/index.vue"),
        meta: {
          title: "通知记录",
          roles: ["XTGL-XTGL-TZJL"],
          menuName: "系统管理",
        },
      },
    ],
  },
  {
    path: "/NPCGeneral",
    component: Layout,
    redirect: "/NPCGeneral",
    meta: {
      title: "人大概况",
      roles: ["XTGL-RDGK"],
      menuName: "系统管理",
    },
    children: [
      {
        path: "NPCOverview",
        name: "NPCOverview",
        component: () =>
          import("@/views/systemManagement/NPCGeneral/NPCOverview/index.vue"),
        meta: {
          title: "人大概述",
          roles: ["XTGL-RDGK-RDGS"],
          menuName: "系统管理",
        },
      },
      {
        path: "NPCCommittee",
        name: "NPCCommittee",
        component: () =>
          import("@/views/systemManagement/NPCGeneral/NPCCommittee/index.vue"),
        meta: {
          title: "人大常委会",
          roles: ["XTGL-RDGK-RDCWH"],
          menuName: "系统管理",
        },
      },
      {
        path: "institutionManagement",
        name: "institutionManagement",
        component: () =>
          import(
            "@/views/systemManagement/NPCGeneral/institutionManagement/institutionManagement/index.vue"
          ),
        meta: {
          title: "机构管理",
          roles: ["XTGL-RDGK-JGGL"],
          menuName: "系统管理",
        },
      },
      {
        path: "institutionDynamic",
        name: "institutionDynamic",
        component: () =>
          import(
            "@/views/systemManagement/NPCGeneral/institutionManagement/institutionDynamic/index.vue"
          ),
        meta: {
          title: "机构动态",
          roles: ["XTGL-RDGK-JGDT"],
          menuName: "系统管理",
        },
      },
      {
        path: "opinionSurvey",
        name: "opinionSurvey",
        component: () =>
          import("@/views/systemManagement/NPCGeneral/opinionSurvey/index.vue"),
        meta: {
          title: "民意调查",
          roles: ["XTGL-RDGK-MYDC"],
          menuName: "系统管理",
        },
      },
      // {
      //   path: 'institutionManagement',
      //   name: 'institutionManagement',
      //   component: ThirdMenu,
      //   redirect: '/institutionManagement',
      //   meta: {
      //     title: '机构管理',
      //     roles: ['XTGL-RDGK-JGGL'],
      //     menuName: '系统管理'
      //   },
      //   children: [
      //     {
      //       path: 'institutionManagement',
      //       name: 'institutionManagement',
      //       component: () => import('@/views/systemManagement/NPCGeneral/institutionManagement/institutionManagement/index.vue'),
      //       meta: {
      //         title: '机构管理',
      //         roles: ['XTGL-RDGK-JGGL-JGGL'],
      //         menuName: '系统管理'
      //       }
      //     },
      //     {
      //       path: 'institutionDynamic',
      //       name: 'institutionDynamic',
      //       component: () => import('@/views/systemManagement/NPCGeneral/institutionManagement/institutionDynamic/index.vue'),
      //       meta: {
      //         title: '机构动态',
      //         roles: ['XTGL-RDGK-JGGL-JGDT'],
      //         menuName: '系统管理'
      //       }
      //     }
      //   ]
      // }
    ],
  },
  {
    path: "/docData",
    component: Layout,
    redirect: "/docData",
    meta: {
      title: "文件资料",
      roles: ["XTGL-WJZL"],
      menuName: "系统管理",
    },
    children: [
      {
        path: "law",
        name: "law",
        component: () =>
          import("@/views/systemManagement/docData/law/index.vue"),
        meta: {
          title: "法律法规",
          roles: ["XTGL-WJZL-FLFG"],
          menuName: "系统管理",
        },
      },
      {
        path: "docBase",
        name: "docBase",
        component: () =>
          import("@/views/systemManagement/docData/docBase/index.vue"),
        meta: {
          title: "资料库",
          roles: ["XTGL-WJZL-ZLK"],
          menuName: "系统管理",
        },
      },
    ],
  },
];

const createRouter = () =>
  new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  });
const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

router.beforeEach(async (to, from, next) => {
  // 正在会议或者加入会议中禁止跳转
  console.log("to", store.getters.meetingState);
  if (store.getters.meetingState) {
    return MessageBox.confirm(
      "您正在房间中,继续操作将退出房间,是否继续?",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(() => {
        window.CRVideo_ExitMeeting();
        store.commit("state/SET_MEETING_STATE", 0);
        next();
      })
      .catch(() => {});
  }
  const zhrd = localStorage.getItem("zhrd");
  const routerInfo = JSON.parse(sessionStorage.getItem("routerInfo"));
  if (zhrd) {
    const hasRoles = store.getters.name;
    if (hasRoles) {
      if (to.path === "/") {
        sessionStorage.removeItem("routerInfo");
        next();
      } else if (to.path === "/login") {
        next({
          path: "/",
        });
      } else if (to.path === "/InstRot") {
        sessionStorage.removeItem("routerInfo");
        await store.dispatch("user/getInfo");
        const { MenuCode } = store.getters;
        const accessRoutes = await store.dispatch(
          "topBar/generateRoutes",
          MenuCode
        );
        // dynamically add accessible routes
        if (accessRoutes.length > 0) {
          router.addRoutes(accessRoutes);
          const path = `${accessRoutes[0].path}/${accessRoutes[0].children[0].path}`;
          next(path);
        } else {
          Message("暂无权限");
          next("/");
        }
      } else if (to.path === "/release") {
        await store.dispatch("user/getInfo");
        const accessRoutes = await store.dispatch(
          "topBar/generateRoutes",
          "DBFW"
        );
        // dynamically add accessible routes
        if (accessRoutes.length > 0) {
          router.addRoutes(accessRoutes);
          const path = "/representativeService/release";
          next(path);
        } else {
          Message("暂无权限");
          next("/");
        }
      } else if (to.path === "/back") {
        await store.dispatch("user/getInfo");
        const accessRoutes = await store.dispatch(
          "topBar/generateRoutes",
          routerInfo.code
        );
        // dynamically add accessible routes
        if (accessRoutes.length > 0) {
          router.addRoutes(accessRoutes);
          const path = routerInfo.path;
          sessionStorage.removeItem("routerInfo");
          next(path);
        } else {
          Message("暂无权限");
          next("/");
        }
      } else {
        if (
          to.path !== "/representativeService/release" &&
          routerInfo &&
          to.path !== routerInfo.path
        ) {
          sessionStorage.removeItem("routerInfo");
        }
        // 模块间路由跳转 重置MenuCode
        // const routerItems = {
        //   JDJD: ['supervisionDecision'],
        //   RSRM: ['appointmentRemoval'],
        //   RDPJ: ['voteRelease', 'voteProject'],
        //   HYGL: ['meetingManagement', 'importantRelease', 'selfConstruction'],
        //   YJBL: ['representativeSuggest'],
        //   DBFW: ['representativeManagement'],
        //   DBJZ: ['representativeStation'],
        //   XZRD: ['ruralManagement'],
        //   SHFB: ['auditRelease'],
        //   XTGL: ['system', 'NPCGeneral']
        // }
        // const target = to.path.split('/')
        // const {
        //   MenuCode
        // } = store.getters
        // for (const k in routerItems) {
        //   if (routerItems[k].includes(target[1]) && MenuCode !== k) {
        //     await store.dispatch('topBar/setMenuCode', k)
        //     await store.dispatch('user/getInfo')
        //     const {
        //       MenuCode
        //     } = store.getters
        //     const accessRoutes = await store.dispatch('topBar/generateRoutes', MenuCode)
        //     // dynamically add accessible routes
        //     if (accessRoutes.length > 0) {
        //       router.addRoutes(accessRoutes)
        //       next(to.path)
        //     } else {
        //       Message('敬请期待')
        //       next('/')
        //     }
        //     return
        //   }
        //   await store.dispatch('user/getInfo')
        //   const parentNode = (to.matched.length && to.matched[0].path) ? to.matched[0].path.split('/')[1] : ''
        //   if (parentNode) {
        //     sessionStorage.setItem('title', to.meta.menuName)
        //   }
        //   next()
        // }
        await store.dispatch("user/getInfo");
        const parentNode =
          to.matched.length && to.matched[0].path
            ? to.matched[0].path.split("/")[1]
            : "";
        if (parentNode) {
          sessionStorage.setItem("title", to.meta.menuName);
        }
        next();
      }
    } else {
      try {
        await store.dispatch("user/getInfo");
        // generate accessible routes map based on roles
        // const accessRoutes = await store.dispatch('permission/generateRoutes')
        await store.dispatch("user/setName", "管理员");
        const Name = JSON.parse(localStorage.getItem("latestAsyncRouteName"));
        store.dispatch("topBar/setMenuCode", Name);
        const accessRoutes = await store.dispatch(
          "topBar/generateRoutes",
          Name
        );
        // dynamically add accessible routes
        router.addRoutes(accessRoutes);
        // hack method to ensure that addRoutes is complete
        // set the replace: true, so the navigation will not leave a history record
        next({
          ...to,
          replace: true,
        });
      } catch (error) {
        localStorage.clear();
        sessionStorage.clear();
        next("/login");
      }
      // next()
    }
  } else {
    if (to.path !== "/login") {
      // alert('您还没有登录，请先登录账户') // 没有就先登录
      // Message({
      //   dangerouslyUseHTMLString: true,
      //   message: '您还没有登录，请先登录账户',
      //   type: 'error'
      // })
      // eslint-disable-next-line no-tabs
      next("/login");
    } else {
      next();
    }
  }
});

export default router;
